<script setup lang="ts">
import type { Component } from 'vue';
import { CircleIcon } from '#shared/components/icons';
import type { AppBreadcrumbsItem } from '#shared/types/ui/AppBreadcrumbs';

const props = withDefaults(
  defineProps<{
    items?: AppBreadcrumbsItem[];
    dividerIcon?: Component;
  }>(),
  { items: () => [], dividerIcon: CircleIcon }
);
</script>

<template>
  <div class="breadcrumbs">
    <template v-for="(item, index) in props.items" :key="index">
      <component
        :is="props.dividerIcon"
        v-if="index !== 0"
        class="breadcrumbs__divider"
        :class="{ breadcrumbs__divider_disabled: !item.link }"
      />
      <NuxtLink
        class="breadcrumbs__item"
        :class="{ breadcrumbs__item_disabled: !item.link }"
        :to="item.link ?? '#'"
      >
        <span class="breadcrumbs__text">{{ item.title }}</span>
      </NuxtLink>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.breadcrumbs {
  display: flex;
  align-items: center;
  gap: 10px;

  &__item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 17px;
    line-height: 22px;
    color: var(--app-color-tertiary);

    &_disabled {
      color: var(--app-color-black-primary);
      pointer-events: none;

      .breadcrumbs__text:after {
        content: none;
      }
    }
  }

  &__divider {
    width: 16px;
    height: 16px;
    color: var(--app-color-tertiary);

    &_disabled {
      color: var(--app-color-black-primary);
    }
  }
}
</style>
